// extracted by mini-css-extract-plugin
export default {"section":"AdditionalInsuranceList_section__Fl++2","isLastBorder":"AdditionalInsuranceList_isLastBorder__O5HF8"};